(function(fox, window) {
	"use strict";

	fox.registerWidget('Intercom', {
		configure: function(options) {
			this._currentState = null;
			this._embedded = false;

			this.registerOptions('', {
				listenWidgets: null,
				listenEvents: ['activate', 'running'],
				widgetOption: 'intercomEnabled',
				defaultState: true,
				customLauncher: false//'#launcher-intercom' //uncoment for use custom launcher
			});

			this.callParent('configure', arguments);
		},

		running: function() {
			var settings = fox.getEnv('intercomSettings') || window.intercomSettings || false;

			if (!settings) return;

			if(this.getOption('customLauncher') !== false) {
				fox.setEnv('intercomSettings', fox.merge(settings, {
					hide_default_launcher: true,
					custom_launcher_selector: '#launcher-intercom'
				}));
			}

			this.setEventListenWidgets();

			this.callParent('running', arguments);
		},

		setEventListenWidgets: function () {
			var lw = this.getOption('listenWidgets');
			if (lw) {
				this.handleEvent(lw, this.getOption('listenEvents'), 'handleEnabledState');
			}
		},

		handleEnabledState: function(o, w) {
			if (w.getOption(this.getOption('widgetOption')) === false) {
				this.disableIC();
			} else if (w.getOption(this.getOption('widgetOption')) === true) {
				this.enableIC();
			} else {
				if (this.getOption('defaultState')) {
					this.enableIC();
				} else {
					this.disableIC();
				}
			}
		},

		disableIC: function() {
			if (this._currentState === false) return;

			if (this._embedded) {
				window.Intercom('shutdown');
				if(this.getOption('customLauncher') !== false) {
					this.showLauncher(false);
				}
				this._currentState = false;
			}
		},

		enableIC: function() {
			if (this._currentState === true) return;

			if (this._embedded) {
				window.Intercom('reattach_activator');
				if(this.getOption('customLauncher') !== false) {
					this.showLauncher(true);
				}
				window.Intercom('update', fox.getEnv('intercomSettings'));
			} else {
				this.embedIC();
				this._embedded = true;
			}

			this._currentState = true;
		},

		embedIC: function() {
			var d = document;
			var i = function () {
				i.c(arguments);
			};
			i.q = [];
			i.c = function (args) {
				i.q.push(args);
			};
			window.Intercom = i;
			var s = d.createElement('script');
			var app_id = fox.getEnv('intercomSettings.app_id');
			s.type = 'text/javascript';
			s.async = true;

			if(this.getOption('customLauncher') !== false) {
				if (!fox.dom.selectFirst('#launcher-intercom')) {
					var self = this;
					var launcher;
					launcher = document.createElement('a');
					launcher.setAttribute('id', self.getOption('customLauncher').substr(1));
					launcher.setAttribute('href', 'mailto:' + app_id + '@intercom-mail.com');
					document.body.appendChild(launcher);

					s.onload = function() {
						self.eventSwitcher();
					};
				}
			}

			s.src = 'https://widget.intercom.io/widget/' + app_id;
			var x = d.getElementsByTagName('script')[0];
			x.parentNode.insertBefore(s, x);
			window.Intercom('update', fox.getEnv('intercomSettings'));
		},

		eventSwitcher: function() {
			this.showLauncher(true);

			window.Intercom('onShow', function() {
				fox.dom.selectFirst('#launcher-intercom').classList.add('open');
			});
			window.Intercom('onHide', function() { 
				fox.dom.selectFirst('#launcher-intercom').classList.remove('open');
			});
		},

		showLauncher: function(b) {
			var el = this.getOption('customLauncher');

			if (b) {
				fox.dom.selectFirst(el).style.display = 'block';
			} else {
				fox.dom.selectFirst(el).style.display = 'none';
			}
		}
	}, 'Controller');
})(fox, window);


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/intercom/intercom.js
// module id = 205
// module chunks = 2